import { environment } from './../../../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConstantesService } from '../../../core/constantes/constantes.service';
import { Observable } from 'rxjs/Observable';
import { Activo } from '../../../core/modelos/activo';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class ActivosService {

    private currentActivoSource: Subject<number> = new Subject();
    currentActivo = this.currentActivoSource.asObservable();

    constructor(private http: HttpClient, private constantes: ConstantesService) { }

    getActivos(): Observable<any> {
        /* return this.constantes.respuestaActivosCacheados ?
            Observable.of(this.constantes.respuestaActivosCacheados) :
            this.http.get(environment.urlBase + 'activos', this.constantes.httpOptions); */
        return this.http.get(environment.urlBase + 'activos', this.constantes.httpOptions);
    }

    getActivosDatosBasicos(): Observable<any> {
        return this.http.get(environment.urlBase + 'activosBasico', this.constantes.httpOptions);
    }

    getActivo(id: number): Observable<any> {
        return this.http.get(environment.urlBase + 'activos/' + id, this.constantes.httpOptions);
    }

    getActivoImagen(id: number): Observable<any> {
        return this.http.get(environment.urlBase + 'activoImagen/' + id, this.constantes.httpOptions);
    }

    updateActivo(activo: Activo): Observable<any> {
        return this.http.put(environment.urlBase + 'activos/' + activo.id, activo, this.constantes.httpOptions);
    }

    addActivo(activo: Activo): Observable<any> {
        return this.http.post<Activo>(environment.urlBase + 'activos', activo, this.constantes.httpOptions);
    }

    deleteActivo(id: number): Observable<any> {
        return this.http.delete(environment.urlBase + 'activos/' + id, this.constantes.httpOptions);
    }
    removeAssetsFromCache() {
        this.constantes.respuestaActivosCacheados = null;
    }
    putAssetOnCache(data, removeold?: boolean) {
        if (!this.constantes.respuestaActivosCacheados || removeold) {
            let imagenSinCabecera;
            data.items.forEach(activo => {
                imagenSinCabecera = activo.imagen ? activo.imagen.split('data:image/jpeg;base64,') : [];
                if (imagenSinCabecera.length > 0) {
                    activo.imagen = imagenSinCabecera[imagenSinCabecera.length - 1];
                }
            });
            this.constantes.respuestaActivosCacheados = data;
        }
    }

    cargarActivos(excel: File): Observable<any> {
        return this.http.post<File>(environment.urlBase + 'importarExcel', {excel}, this.constantes.httpOptions);
    }

    getActivoId(codigo: string): Observable<any> {
        return this.http.get(environment.urlBase + 'activosByCodigo/' + codigo, this.constantes.httpOptions);
    }

    setCurrentActivo(idActivo: number) {
        this.currentActivoSource.next(idActivo)
    }

    /* cargarActivos(excel: File): Observable<any> {

        const headers = new HttpHeaders({
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + sessionStorage.getItem('tokenBim')
          });

        return this.http.post<File>(environment.urlBase + 'importarExcel', {excel}, {headers});
    } */

}



// WEBPACK FOOTER //
// ./src/app/main/content/activos/activos.service.ts